import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { Metamodel } from 'app/model/base/model';
import { EloquaObjectDataset } from 'app/model/dataset/eloqua.dataset';
import { EloquaLinkedService } from 'app/model/linkedservice/eloqua.linkedservice';
import { deprecatedConnectorDocLink } from 'app/shared/constants/links.const';
import { format } from 'app/shared/utils/string.util';

export const eloquaObjectMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(EloquaObjectDataset).name,
    displayName: format(stringResources.ModelName_DisplayTextLegacyTemplate, stringResources.Eloqua_DisplayText),
    supportLinkedServiceTypes: [Metamodel.modelFor(EloquaLinkedService).name],
    warningMessage: stringResources.Connector_Legacy_IsDeprecatedWarning,
    warningMessageHyperlink: deprecatedConnectorDocLink,
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-Oracle'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    category: ['ServicesApps']
};
